import React from 'react';
import PageBase from '../../../widgets/PageBase/PageBase';
import { injectIntl } from 'react-intl';

function ThankYouPage(props) {
  return (
    <PageBase navigation={['MRS']} includeInactiveBranches>
      <div style={{ fontSize: 20 }}>
        {props.intl.formatMessage({
          id: 'mrs_thank_you'
        })}
      </div>
    </PageBase>
  );
}

export default injectIntl(ThankYouPage);
